import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const getSubcategories = createSelector(
  state => state.orm,
  ormCreateSelector(orm, session => {
    return session.PlanSubcategory.all().toModelArray()
  })
)
